import { useMemo } from 'react'
import { usePrefersReducedMotion } from './usePrefersReducedMotion'

/**
 * Derives an odometer display string from scroll progress.
 *
 * @param {number} target   - numeric target value
 * @param {number} progress - scroll progress 0..1 (--p of the containing section)
 * @param {'kunit'|'infinity'|'plus'|'plain'} fmt - formatting mode
 * @returns {string} formatted display string
 */
export function useOdometer(target, progress, fmt = 'plain') {
    const reducedMotion = usePrefersReducedMotion()

    return useMemo(() => {
        const value = reducedMotion ? target : target * Math.max(0, Math.min(1, progress))
        return formatOdo(value, fmt)
    }, [target, progress, fmt, reducedMotion])
}

function formatOdo(n, fmt) {
    if (fmt === 'infinity') return n >= 0.95 ? '∞' : Math.floor(n * 8) + '·'
    if (fmt === 'kunit') {
        if (n >= 1000000) return (n / 1000000).toFixed(n >= 999500 ? 0 : 1) + 'M'
        if (n >= 1000) return Math.floor(n / 1000) + 'K'
        return Math.floor(n).toString()
    }
    if (fmt === 'plus') return Math.floor(n) + '+'
    return Math.floor(n).toString()
}
